import useJwt from "@/auth/jwt/useJwt";

export const isUserLoggedIn = () => {
  let searchParams = new URLSearchParams(window.location.search);
  let brandRef = searchParams.get("brandRef");
  let brand_ref = searchParams.get("brand_ref");

  let brandObj = {};

  if (brand_ref) {
    if (searchParams.get("status") == "success") {
      let brands =
        JSON.parse(localStorage.getItem(window.brandLocalStorage))?.filter(
          (o) => {
            return o.brandRef != brand_ref;
          }
        ) || [];
      brands.push({
        brandRef: searchParams.get("brand_ref"),
        accessToken: searchParams.get("access_token"),
        refreshToken: searchParams.get("refresh_token"),
        payload: searchParams.get("payload"),
      });
      localStorage.setItem(window.brandLocalStorage, JSON.stringify(brands));
    }
  }
  if (brandRef) {
    let brands = JSON.parse(localStorage.getItem(window.brandLocalStorage));
    brandObj = brands?.find((o) => {
      return o.brandRef == brandRef;
    });
  } else if (brand_ref) {
    if (searchParams.get("status") == "success") {
      let brands = JSON.parse(localStorage.getItem(window.brandLocalStorage));
      brandObj = brands?.find((o) => {
        return o.brandRef == brand_ref;
      });
    }
  }
  return brandObj?.brandRef || false;
};

export const getUserData = () => JSON.parse(localStorage.getItem("userData"));

export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return "/";
  if (userRole === "client") return { name: "access-control" };
  return { name: "auth-login" };
};
